// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  V1AutocompleteData,
  V1AutocompleteResponses,
  V1PlaceData,
  V1PlaceResponses,
  V1ReverseData,
  V1ReverseResponses,
  V1SearchData,
  V1SearchResponses,
  V1SearchStructuredData,
  V1SearchStructuredResponses,
} from './types.gen';

export type Options<
  TData extends TDataShape = TDataShape,
  ThrowOnError extends boolean = boolean,
  TResponse = unknown,
> = Options2<TData, ThrowOnError, TResponse> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Forward geocoding to find a place by searching for an address or name
 *
 * Geocoding is the process of matching an address or other text to its corresponding geographic coordinates.
 */
export const geocoderApiV1Search = <ThrowOnError extends boolean = false>(
  options: Options<V1SearchData, ThrowOnError>,
) =>
  (options.client ?? client).get<V1SearchResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { sources: { array: { explode: false } }, layers: { array: { explode: false } } } },
    url: '/v1/search',
    ...options,
  });

/**
 * Reverse geocoding to find what is located at a certain coordinate location
 *
 * Reverse geocoding is used for finding places or addresses near a latitude, longitude pair—like clicking on a map to see what's there when the map doesn't show it otherwise.
 */
export const geocoderApiV1Reverse = <ThrowOnError extends boolean = false>(
  options: Options<V1ReverseData, ThrowOnError>,
) =>
  (options.client ?? client).get<V1ReverseResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { sources: { array: { explode: false } }, layers: { array: { explode: false } } } },
    url: '/v1/reverse',
    ...options,
  });

/**
 * Autocomplete to give real-time result suggestions without having to type the whole location
 *
 * If you are building an end-user application, you can use the /autocomplete endpoint alongside /search to enable real-time feedback. This type-ahead functionality helps users find what they are looking for, without requiring them to fully specify their search term. Typically, the user starts typing and a drop-down list appears where they can choose the term from the list below.
 */
export const geocoderApiV1Autocomplete = <ThrowOnError extends boolean = false>(
  options: Options<V1AutocompleteData, ThrowOnError>,
) =>
  (options.client ?? client).get<V1AutocompleteResponses, unknown, ThrowOnError>({
    querySerializer: { parameters: { sources: { array: { explode: false } }, layers: { array: { explode: false } } } },
    url: '/v1/autocomplete',
    ...options,
  });

/**
 * Structured Geocoding (beta) to find a place with data already separated into housenumber, street, city, etc
 *
 * With structured geocoding, you can search for the individual parts of a location.
 */
export const geocoderApiV1SearchStructured = <ThrowOnError extends boolean = false>(
  options?: Options<V1SearchStructuredData, ThrowOnError>,
) =>
  (options?.client ?? client).get<V1SearchStructuredResponses, unknown, ThrowOnError>({
    url: '/v1/search/structured',
    ...options,
  });

/**
 * Place endpoint for details on a place returned from a previous query
 *
 * When you know an identification number and the source it came from, you can use Pelias to get details on the location.
 */
export const geocoderApiV1Place = <ThrowOnError extends boolean = false>(options: Options<V1PlaceData, ThrowOnError>) =>
  (options.client ?? client).get<V1PlaceResponses, unknown, ThrowOnError>({ url: '/v1/place', ...options });
